import * as React from 'react';

const gdprSmall = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="4" fill="white"/>
    <g clip-path="url(#clip0_23086_12636)">
    <path d="M17.5641 5.56028C17.4173 15.6837 10.0273 18.0428 10.0177 18.0522C9.94679 18.0428 2.55204 15.6837 2.40527 5.56028L9.9846 1.99805L17.5641 5.56028Z" fill="url(#paint0_linear_23086_12636)"/>
    <path d="M18.2416 4.83603L10.1885 1.04619C10.0596 0.984604 9.90989 0.984604 9.78099 1.04619L1.72789 4.83603C1.56187 4.91271 1.45622 5.07942 1.45778 5.26227C1.45778 15.8261 9.15577 19 9.98466 19C10.8137 19 18.5115 15.8261 18.5115 5.26227C18.5133 5.07942 18.4076 4.91271 18.2416 4.83603ZM10.0178 18.0526C9.94684 18.0432 2.55209 15.6841 2.40533 5.56065L9.98466 1.99842L17.5642 5.56065C17.4174 15.6841 10.0273 18.0432 10.0178 18.0526Z" fill="url(#paint1_linear_23086_12636)"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8536 6.64645C15.0488 6.84171 15.0488 7.15829 14.8536 7.35355L9.85355 12.3536C9.65829 12.5488 9.34171 12.5488 9.14645 12.3536L6.64645 9.85355C6.45118 9.65829 6.45118 9.34171 6.64645 9.14645C6.84171 8.95118 7.15829 8.95118 7.35355 9.14645L9.5 11.2929L14.1464 6.64645C14.3417 6.45118 14.6583 6.45118 14.8536 6.64645Z" fill="url(#paint2_linear_23086_12636)"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_23086_12636" x1="15.178" y1="15.4552" x2="-3.83194" y2="8.80804" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint1_linear_23086_12636" x1="13.9973" y1="14.2857" x2="-8.7207" y2="1.22477" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BDD1E7"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint2_linear_23086_12636" x1="12.75" y1="10.9286" x2="4.08651" y2="3.481" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BDD1E7"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <clipPath id="clip0_23086_12636">
    <rect width="18" height="18" fill="white" transform="translate(1 1)"/>
    </clipPath>
    </defs>
    </svg>
);

export default gdprSmall;